module.exports = __webpack_public_path__ + "static/media/IMG_1276.f0970b1c.jpg";